module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reports-rooms ui statistics"
  }, [_c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.rooms_vaild.length))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("房间")])]), _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.rooms_filter_checked.length))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("入住")])]), _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.rooms_filter_avaliable.length))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("空房")])]), _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value",
    style: ({
      color: _vm.color(_vm.rooms_filter_checked.length / _vm.rooms_vaild.length)
    })
  }, [_vm._v(_vm._s(_vm.$formatters.to_percent(_vm.rooms_filter_checked.length / _vm.rooms_vaild.length, 1)))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("当前房间入住率")])]), _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value",
    style: ({
      color: _vm.color(_vm.overall_occupancy_rate)
    })
  }, [_vm._v(_vm._s(_vm.$formatters.to_percent(_vm.overall_occupancy_rate, 1)))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("整体出租率 (" + _vm._s(_vm.from_text) + "起算)")])]), _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.rooms_filter_perorder.length))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("预定")])]), _c('table', {
    staticClass: "ui celled structured table"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.rooms_details), function(room) {
    return _c('tr', [_c('th', {
      staticClass: "center aligned",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.$router.$go.room({
            no: room.no
          })
        }
      }
    }, [_vm._v(_vm._s(room.no))]), _c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(room.rented_days) + " / " + _vm._s(_vm.operating_days.days))]), _c('td', {
      staticClass: "center aligned",
      style: ([{
        color: _vm.color(room.occupancy_rate)
      }, _vm.fontsize(1 - room.occupancy_rate)])
    }, [_vm._v(_vm._s(_vm.$formatters.to_percent(room.occupancy_rate)))]), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v(_vm._s(room._r.price_month) + " ")]), _c('td', {
      staticClass: "right aligned"
    }, [_vm._v(_vm._s((room._r.price_month * room.occupancy_rate).toFixed(2)) + " ")]), _c('td', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(room.rented_recent) + " / 30")]), _c('td', {
      staticClass: "center aligned",
      style: ([{
        color: _vm.color(room.occupancy_rate_recent)
      }, _vm.fontsize(1 - room.occupancy_rate_recent)])
    }, [_vm._v(_vm._s(_vm.$formatters.to_percent(room.occupancy_rate_recent)))])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "center aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("房號")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("整體")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("最近30天")])]), _c('tr', [_c('th', {
    staticClass: "center aligned"
  }, [_vm._v("出租天數")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("出租率")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("月租金")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("平均月租金")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("出租天數")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("出租率")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c740a7a0","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/reports/Rooms.vue
// module id = 545
// module chunks = 0